module.exports = __webpack_public_path__ + "img/case_comm.33eff76a.png";